import { render, staticRenderFns } from "./Cases-detail.vue?vue&type=template&id=66a32f45&scoped=true&"
import script from "./Cases-detail.vue?vue&type=script&lang=js&"
export * from "./Cases-detail.vue?vue&type=script&lang=js&"
import style0 from "./Cases-detail.vue?vue&type=style&index=0&id=66a32f45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a32f45",
  null
  
)

export default component.exports